import script from "./EventCard.vue?vue&type=script&setup=true&lang=js"
export * from "./EventCard.vue?vue&type=script&setup=true&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=eb59d5a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb59d5a4"]])

export default __exports__